import { render, staticRenderFns } from "./DialogFlipCardPreview.vue?vue&type=template&id=56b8b7fa&scoped=true"
import script from "./DialogFlipCardPreview.vue?vue&type=script&lang=js"
export * from "./DialogFlipCardPreview.vue?vue&type=script&lang=js"
import style0 from "./DialogFlipCardPreview.vue?vue&type=style&index=0&id=56b8b7fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b8b7fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b8b7fa')) {
      api.createRecord('56b8b7fa', component.options)
    } else {
      api.reload('56b8b7fa', component.options)
    }
    module.hot.accept("./DialogFlipCardPreview.vue?vue&type=template&id=56b8b7fa&scoped=true", function () {
      api.rerender('56b8b7fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogFlipCardPreview.vue"
export default component.exports